import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, SORT } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './advanced-material.reducer';

export const AdvancedMaterial = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search));

  const advancedMaterialList = useAppSelector(state => state.advancedMaterial.entities);
  const loading = useAppSelector(state => state.advancedMaterial.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    } else {
      return order === ASC ? faSortUp : faSortDown;
    }
  };

  return (
    <div>
      <h2 id="advanced-material-heading" data-cy="AdvancedMaterialHeading">
        <Translate contentKey="coconApp.advancedMaterial.home.title">Advanced Materials</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="coconApp.advancedMaterial.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/advanced-material/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="coconApp.advancedMaterial.home.createLabel">Create new Advanced Material</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {advancedMaterialList && advancedMaterialList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="coconApp.advancedMaterial.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('molecularFormula')}>
                  <Translate contentKey="coconApp.advancedMaterial.molecularFormula">Molecular Formula</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('molecularFormula')} />
                </th>
                <th className="hand" onClick={sort('trivialName')}>
                  <Translate contentKey="coconApp.advancedMaterial.trivialName">Trivial Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('trivialName')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {advancedMaterialList.map((advancedMaterial, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/advanced-material/${advancedMaterial.id}`} color="link" size="sm">
                      {advancedMaterial.id}
                    </Button>
                  </td>
                  <td>{advancedMaterial.molecularFormula}</td>
                  <td>{advancedMaterial.trivialName}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/advanced-material/${advancedMaterial.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/advanced-material/${advancedMaterial.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (location.href = `/advanced-material/${advancedMaterial.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="coconApp.advancedMaterial.home.notFound">No Advanced Materials found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default AdvancedMaterial;
